import React from 'react';

/**
 * Privacy Policy — required for Google Play Store submission.
 * Plain page, no auth required. Linked from the Play Console store
 * listing as: https://cleanpro-ops.com/privacy
 */
export default function Privacy() {
  return (
    <div style={{ maxWidth: 820, margin: '0 auto', padding: '40px 24px', fontFamily: 'system-ui, sans-serif', color: '#1a1a1a', lineHeight: 1.55 }}>
      <h1 style={{ fontSize: 28, marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: '#666', fontSize: 13, marginBottom: 24 }}>
        Last updated: <strong>February 2026</strong>
      </p>

      <p>
        This Privacy Policy describes how <strong>CleanPro Ops</strong> ("we", "us") collects, uses, and protects information when you use our web application and Android mobile app.
      </p>

      <h2 style={{ fontSize: 18, marginTop: 28 }}>1. Information We Collect</h2>
      <ul>
        <li><strong>Account information</strong>: name, email address, phone number, role (admin / building member).</li>
        <li><strong>Building & financial records</strong>: apartment data, owners/tenants, payments, invoices, repairs, expenses, statements, reserve fund — entered by you to run your property operations.</li>
        <li><strong>Device & push tokens</strong> (mobile only): a Firebase Cloud Messaging registration token so we can deliver notifications you opted into.</li>
        <li><strong>Photos</strong> (optional): only if you attach a photo to a repair / receipt; stored on our servers.</li>
        <li><strong>Authentication tokens</strong>: stored on-device (Android KeyStore) so you stay logged in.</li>
      </ul>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>2. How We Use Information</h2>
      <ul>
        <li>To operate the platform: show your buildings, apartments, payments, invoices, statements, and PDFs.</li>
        <li>To send push notifications you have enabled (new payment, overdue invoice, insurance / elevator expiry, repair created, statement generated, owner change).</li>
        <li>To secure your account and comply with legal obligations.</li>
      </ul>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>3. Data Sharing</h2>
      <p>
        We do not sell or rent your personal information. We share data only with the infrastructure providers required to deliver the service (hosting, MongoDB, Firebase Cloud Messaging). All transit is encrypted via HTTPS.
      </p>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>4. Data Retention</h2>
      <p>
        Financial and operational records are retained for as long as your account is active or as required by applicable accounting law. You may request deletion at any time by contacting us; we will erase your personal data within 30 days unless legally required to keep it longer.
      </p>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>5. Your Rights</h2>
      <ul>
        <li>Access, correct, or delete your personal data.</li>
        <li>Withdraw consent for push notifications at any time from your device settings.</li>
        <li>Export your data in machine-readable format on request.</li>
      </ul>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>6. Security</h2>
      <p>
        We use industry-standard encryption (HTTPS / TLS) for all network traffic. Passwords are hashed with bcrypt. Mobile authentication tokens are stored inside the Android KeyStore (Capacitor Preferences).
      </p>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>7. Children's Privacy</h2>
      <p>
        CleanPro Ops is a business product not directed at children under 16. We do not knowingly collect data from children.
      </p>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>8. Changes to this Policy</h2>
      <p>
        We may update this policy from time to time. Material changes will be communicated in-app and by email. Continued use of the app after a change constitutes acceptance.
      </p>

      <h2 style={{ fontSize: 18, marginTop: 24 }}>9. Contact</h2>
      <p>
        For privacy-related questions or data requests, contact: <a href="mailto:micbuilding@gmail.com">micbuilding@gmail.com</a>
      </p>
    </div>
  );
}
